import { getDefaultDisplayMode } from "../../../components-ui/resizable-sidebar";
import { IDongBoCongNoRequest } from "../../../model/request/dong-bo/IDongBoCongNoRequest";
import { IDongBoCongNoSinhVien } from "../../../model/respone/dong-bo/IDongBoCongNoSinhVien";
import { IDongBoCongNoActionTypes } from "../../action-types/dong-bo/IDongBoCongNoAction";
import { IDongBoCongNoReducer } from "../../reducer-model/dong-bo/IDongBoCongNoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDongBoCongNoReducer = {
  sinhViens: [],
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  displayMode: getDefaultDisplayMode(),
  request: {} as IDongBoCongNoRequest,
} as IDongBoCongNoReducer;

export const dongBoCongNoReducer = (
  state: IDongBoCongNoReducer = iniState,
  action: IDongBoCongNoActionTypes
): IDongBoCongNoReducer => {
  switch (action.type) {
    case "DONG_BO_CONG_NO_LOAD_START":
      return {
        ...state,
        sinhViens: [] as IDongBoCongNoSinhVien[],
        status: eReducerStatusBase.is_loading,
      };
    case "DONG_BO_CONG_NO_LOAD_SUCCESS":
      return {
        ...state,
        sinhViens: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "DONG_BO_CONG_NO_LOAD_ERRR":
      return {
        ...state,
        sinhViens: [] as IDongBoCongNoSinhVien[],
        status: eReducerStatusBase.is_completed,
      };
    case "DONG_BO_CONG_NO_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "DONG_BO_CONG_NO_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        focusedCell: undefined,
        idSelections: [],
        request: {
          ...state.request,
          id_lops: action.payload?.dm_lop_ids ?? [],
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "DONG_BO_CONG_NO_SYNC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DONG_BO_CONG_NO_SYNC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DONG_BO_CONG_NO_SYNC_ERR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "DONG_BO_CONG_NO_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };
    case "DONG_BO_CONG_NO_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };

    default:
      return state;
  }
};
